import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6nu7ayhqaw: FaireBrandEntity = {
  token: "b_6nu7ayhqaw",
  type: "brand",
  name: "Fabdaz",
  avatarUrl:
    "https://cdn.faire.com/fastly/9baaebb07b5fbe88ce90f2f9e3b66aaca07fea09ad791f434c67c1f8b43ed69a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/3eb2ad70d3813e6eadfcf24f3e4a31140ad8fb84a144bd7941f483a664cd6229.png",
  logoUrl:
    "https://cdn.faire.com/fastly/9baaebb07b5fbe88ce90f2f9e3b66aaca07fea09ad791f434c67c1f8b43ed69a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3eb2ad70d3813e6eadfcf24f3e4a31140ad8fb84a144bd7941f483a664cd6229.png",
  location: "Chattanooga, TN, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 530,
  isTopShop: true,
  isInsider: true,
  description:
    "Fabdaz - manufacturer of apparel, enamel pins, stickers & more.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:14.031Z",
    importedBy: "entity-db-cli",
  },
};
